import MyTakeAwayPage from '../components/my-take-away-page';

/* @ngInject */
export default function MyTakeAwayCtrl($scope) {
  $scope.MyTakeAwayPage = MyTakeAwayPage;
}
